import ModelTypeConstants from 'constants/ModelTypeConstants';
import {NoteLinkedObject, NotePart} from 'notebook/util/NoteUtilConstants';

export default function getNotePartType(notePart: NotePart): string | null {
  if (
    notePart.type !== ModelTypeConstants.NOTE_LINKED_OBJECT &&
    notePart.type !== ModelTypeConstants.NOTE_LINKED_DATA
  ) {
    return notePart.type;
  }
  if (!notePart.item) {
    return null;
  }
  return (notePart.item as NoteLinkedObject).type;
}
